export type CleanGQL<T> =
    T extends null ? null :
    T extends undefined ? null :
    T extends Date ? Date :
    T extends Array<infer R> ? CleanGQL<R>[] :
    T extends object ? {
        [key in keyof Omit<T, "__typename">]: CleanGQL<T[key]>
    } :
    T;

// const num: CleanGQL<number>;
// const str: CleanGQL<string>;
// const nll: CleanGQL<null>;
// const dt: CleanGQL<Date>;
// const undef: CleanGQL<undefined>;
// const obj: CleanGQL<{x: number, __typename: string}>;
// const arr: CleanGQL<{x: number, __typename: string, y: undefined}[]>;

/**
 * Removes __typename from objects and arrays
 * @param obj
 * @returns
 */
export function prepareDataGQL<T>(obj: T): CleanGQL<T> {
    if (obj) {
        if (Array.isArray(obj)) {
            return obj.map(prepareDataGQL) as any as CleanGQL<T>;
        }
        if (typeof obj === "object") {
            const res: T = {} as T;
            for (const key in obj) {
                if (key === "__typename") {
                    continue;
                }
                if (obj.hasOwnProperty(key)) {
                    res[key] = prepareDataGQL(obj[key]) as any;
                }
            }
            return res as any as CleanGQL<T>;
        }
    }

    if (obj === undefined) {
        // tslint:disable-next-line:no-null-keyword
        return null;
    }

    return obj as any as CleanGQL<T>;
}

export function updateTypeName<T>(obj: T, value: string): T {
    return {
        ...obj,
        __typename: value
    };
}
